import React from 'react';
import { Image } from 'react-native';
import withPress from 'src/hoc/withPress';
import withDefaultIconProps from './withDefaultIconProps';
const RemoteIcon = ({ uri, size, style, }) => {
    return (React.createElement(Image, { source: { uri }, resizeMode: "center", style: [{ height: size, width: size }, style] }));
};
export default withPress(withDefaultIconProps(RemoteIcon));
